// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"9906b887","246":"e9130151","254":"cb483118","373":"61abcd2c","422":"13afa4cb","658":"6984a27d"}[chunkId] + ".js";
};